import { useState } from 'react'
import { getAIProviderOption } from '@creanizer/types'
import { useSettingsStore } from '../../stores/settingsStore'
import { ApiKeyList } from './ApiKeyList'

interface ApiKeyManagerProps {
  isOpen: boolean
  onClose: () => void
}

export function ApiKeyManager({ isOpen, onClose }: ApiKeyManagerProps) {
  const {
    selectedProvider,
    addApiKey,
    getApiKeysForProvider,
  } = useSettingsStore()
  const [showAddForm, setShowAddForm] = useState(false)
  const [newKeyName, setNewKeyName] = useState('')
  const [newKeyValue, setNewKeyValue] = useState('')
  const provider = getAIProviderOption(selectedProvider)
  const apiKeys = getApiKeysForProvider()

  if (!isOpen) return null

  const addKey = async () => {
    if (!newKeyValue.trim()) return
    const keyName = newKeyName.trim() || `${provider.label}キー #${apiKeys.length + 1}`
    try {
      await addApiKey(keyName, newKeyValue.trim(), selectedProvider)
      setNewKeyName('')
      setNewKeyValue('')
      setShowAddForm(false)
    } catch (error) {
      alert(error instanceof Error ? error.message : 'APIキーの追加に失敗しました')
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="max-h-[80vh] w-full max-w-4xl overflow-hidden rounded-lg bg-white">
        <div className="flex items-center justify-between border-b p-6">
          <h2 className="text-2xl font-bold">{provider.label} APIキー管理</h2>
          <button className="text-gray-600" onClick={onClose}>閉じる</button>
        </div>
        <div className="space-y-5 p-6">
          {!showAddForm ? (
            <button className="btn btn-primary" onClick={() => setShowAddForm(true)}>
              新しいAPIキーを追加
            </button>
          ) : (
            <div className="space-y-3 rounded bg-gray-50 p-4">
              <input
                type="text"
                className="w-full rounded border px-3 py-2"
                placeholder="キーの名前（省略可）"
                value={newKeyName}
                onChange={event => setNewKeyName(event.target.value)}
              />
              <input
                type="password"
                className="w-full rounded border px-3 py-2"
                placeholder={provider.apiKeyPlaceholder}
                value={newKeyValue}
                onChange={event => setNewKeyValue(event.target.value)}
              />
              <div className="flex gap-2">
                <button className="btn btn-primary" onClick={() => void addKey()}>
                  追加
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowAddForm(false)}
                >
                  キャンセル
                </button>
              </div>
            </div>
          )}
          <ApiKeyList apiKeys={apiKeys} />
          <p className="rounded bg-blue-50 p-4 text-sm text-blue-800">
            レート制限に達したキーは、同じプロバイダー内の利用可能なキーへ
            自動的に切り替わります。
          </p>
        </div>
      </div>
    </div>
  )
}
